export default __webpack_public_path__ + "static/media/twitter.6dafe6df.svg";